import { MissingRequiredParameterError } from './errors';
import { integrationDataFromQuery } from './integration-data';
export function thankYouDataFromQuery(query) {
  const {
    minStartDate,
    maxStartDate,
    navigateTo,
    verticalStatusContent,
    biOptions
  } = integrationDataFromQuery(query);
  const orderId = query.get('orderId');
  if (!orderId) {
    throw new MissingRequiredParameterError('orderId');
  }
  return {
    successful: true,
    ownerDemo: query.get('ownerDemo') === 'true',
    orderId,
    planId: undefined,
    minStartDate,
    maxStartDate,
    navigateTo,
    verticalStatusContent,
    biOptions
  };
}
export function thankYouDataToQuery(data) {
  const query = new URLSearchParams();
  query.set('orderId', data.purchaseData.orderId);
  data.ownerDemo && query.set('ownerDemo', 'true');
  const {
    navigateTo,
    minStartDate,
    maxStartDate,
    biOptions,
    verticalStatusContent
  } = data.purchaseData.checkoutData.integrationData;
  navigateTo && query.set('destination', navigateTo);
  minStartDate && query.set('minStartDate', minStartDate);
  maxStartDate && query.set('maxStartDate', maxStartDate);
  if (biOptions) {
    biOptions.referralInfo && query.set('referral', biOptions.referralInfo);
    biOptions.referralId && query.set('referralId', biOptions.referralId);
  }
  if (verticalStatusContent) {
    verticalStatusContent.titleText && query.set('thankYouTitle', verticalStatusContent.titleText);
    verticalStatusContent.contentText && query.set('thankYouMessage', verticalStatusContent.contentText);
    verticalStatusContent.buttonText && query.set('thankYouCTA', verticalStatusContent.buttonText);
  }
  return query;
}
//# sourceMappingURL=thank-you-data.js.map